<div class="card-body">
  <div class="d-md-flex align-items-center bg-white">
    <div class="ml-auto mt-3 mt-md-0">
      <button class="btn btn-outline-primary" (click)="add()">{{'prodotti.Add' | translate}}</button>
    </div>
  </div>
</div>
<div class="card-body">
  <div *ngFor="let item of items">
    <div class="form-group">
      <label class="control-label">{{'prodotti.Categoria' | translate}}</label>
      <input type="text" id="firstName" [(ngModel)]="item.cat" (ngModelChange)="ItemsChanged()" class="form-control" placeholder="{{'prodotti.Categoria' | translate}}">
    </div>
    <div class="d-md-flex align-items-center bg-white">
      <div class="ml-auto mt-3 mt-md-0">
        <button class="btn btn-outline-primary" (click)="addTag(item)">{{'prodotti.Add' | translate}}</button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle mb-0 no-wrap">
        <thead>
        <tr>
          <th>{{'prodotti.Label' | translate}}</th>
          <th scope="col">{{'prodotti.Value' | translate}}</th>
          <th scope="col">{{'prodotti.Actions' | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of item.tags">
          <td>
            <input type="text" [(ngModel)]="data.label" (ngModelChange)="ItemsChanged()" class="form-control" placeholder="{{'prodotti.Label' | translate}}">
          </td>
          <td>
            <input type="text" [(ngModel)]="data.value" (ngModelChange)="ItemsChanged()" class="form-control" placeholder="{{'prodotti.Value' | translate}}">
          </td>
          <td class="align-middle">
            <a href="javascript:void(0)" class="link text-danger font-16 font-weight-bold" (click)='delete(item,data)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
